import {Tabs} from 'antd';
import {Outlet, useNavigate} from "react-router";
import {Flower1RoomId, Flower2RoomId, Flower4RoomId, Flower3RoomId,
    Harvest1RoomId, Harvest2RoomId} from "../../api/RoomConstants";

export const CultivationApp = ({session, roomMap, numTasks}) => {
    const navigate = useNavigate();
    const onTabClick = (key, event) => {
        switch (key) {
            case 'Strains':
                navigate('/cultivationapp/strains');
                break;
            case 'Flower1':
                navigate('/cultivationapp/flower1');
                break;
            case 'Flower2':
                navigate('/cultivationapp/flower2');
                break;
            case 'Flower3':
                navigate('/cultivationapp/flower3');
                break;
            case 'Flower4':
                navigate('/cultivationapp/flower4');
                break;
            case 'Harvest1':
                navigate('/cultivationapp/harvest1');
                break;
            case 'Harvest2':
                navigate('/cultivationapp/harvest2');
                break;
            case 'Batch':
                navigate('/cultivationapp/batch');
                break;
            case 'Search':
                navigate('/cultivationapp/search');
                break;
            case 'MainMenu':
                navigate('/');
                break;
            default:
        }
    };

    // const onTabClick = (key, e) => {
    //     console.log(`tab ${key}`);
    // }

    const items = [
        {
            key: 'Strains',
            label: 'Strains',
            children: <div />
        },
        {
            key: 'Batch',
            label: 'Run/Batch',
            children: <div />
        },
        {
            key: 'Flower1',
            label: roomMap[Flower1RoomId] ? roomMap[Flower1RoomId].name : 'Flower1',
            children: <div />
        },
        {
            key: 'Flower2',
            label: roomMap[Flower2RoomId] ? roomMap[Flower2RoomId].name : 'Flower2',
            children: <div />
        },
        {
            key: 'Flower3',
            label: roomMap[Flower3RoomId] ? roomMap[Flower3RoomId].name : 'Flower3',
            children: <div />
        },
        {
            key: 'Flower4',
            label: roomMap[Flower4RoomId] ? roomMap[Flower4RoomId].name : 'Flower4',
            children: <div />
        },
        {
            key: 'Harvest1',
            label: roomMap[Harvest1RoomId] ? roomMap[Harvest1RoomId].name : 'Harvest1',
            children: <div />
        },
        {
            key: 'Harvest2',
            label: roomMap[Harvest2RoomId] ? roomMap[Harvest2RoomId].name : 'Harvest2',
            children: <div />
        },
        {
            key: 'Search',
            label: 'Search',
            children: <div />
        },
        {
            key: 'MainMenu',
            label: 'Main Menu',
            children: <div />
        }
    ];

    return <>
        <Tabs defaultActiveKey={"Flower1"} items={items} onTabClick={onTabClick}/>
        <Outlet />
    </>
}